import React from 'react';

import type { RouteObject } from 'react-router-dom';

import Pages from '@/pages';

const GasThreadMeteringPoints = React.lazy(
  () => import('@/pages/GasThreadDetails/views/MeteringPoints'),
);
const GasThreadMeteringPointsSectors = React.lazy(
  () => import('@/pages/GasThreadDetails/views/Sectors'),
);

const GasThreadInformation = React.lazy(
  () => import('@/pages/GasThreadDetails/views/Information'),
);

export const gasDistributionStationGasThreadRoutes: RouteObject[] = [
  {
    element: <GasThreadInformation />,
    index: true,
  },
  {
    path: `${Pages.METERING_POINTS}`,
    element: <GasThreadMeteringPoints />,
  },

  {
    path: `${Pages.SECTORS}`,
    element: <GasThreadMeteringPointsSectors />,
  },
];
